import * as React from 'react'

interface Props {
    message?: {
        args: {
            ct: number
            wt: number
        }
    }
}
export default class SlowTranslationSnippets extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let count = <div></div>

        if (message) {
            count = <strong>{message.args.ct} times</strong>
        }

        return (
            <div>
                <p>
                    This request loads and calculates translation snippets {count} instead of loading them directly from the cache.
                    Translations should always be cached, because its otherwise a too expensive operation to load them without a cache.
                </p>
            </div>
        )
    }
}
